export default __webpack_public_path__ + "static/media/hiclipart_1.bf31c7c9.png";